import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { conversationsAPI } from "api/Interactions/ConversationsAPI";

interface AddConversationPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newConversation: any) => void;
}

const AddConversationPopup: React.FC<AddConversationPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Conversation"
      createFunction={conversationsAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description" },
        { name: "linked_campaign", label: "Campaign", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddConversationPopup;
